import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mx_medium_date",
})
export class ParseDatePipe implements PipeTransform {
  transform(value: string): Date {
    if (value == null) {
      return;
    }

    let date_split = value.split("-");
    let date_string = `${date_split[2]}-${date_split[1]}-${date_split[0]}T00:00:00`;
    let date_now = new Date(date_string);
    return date_now;
  }
}
